import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AIIconProps {
  className?: string;
  size?: number;
}

export default function AIIcon({ className, size = 20 }: AIIconProps) {
  return (
    <div className={cn("relative flex items-center justify-center shrink-0", className)}>
      {/* Background glow layers */}
      <div className="absolute inset-0 bg-blue-500/30 blur-[6px] rounded-full animate-pulse" />
      <div className="absolute inset-0 bg-indigo-500/20 blur-[12px] rounded-full animate-[pulse_3s_infinite]" />
      
      {/* Spinning orbit effect */}
      <div className="absolute inset-[-4px] border border-blue-400/20 rounded-full animate-[spin_4s_linear_infinite]" />
      <div className="absolute inset-[-4px] border-t-blue-500/40 rounded-full animate-[spin_3s_linear_infinite]" />

      <div className="relative bg-gradient-to-tr from-blue-600 to-indigo-500 p-1.5 rounded-full shadow-[0_0_15px_rgba(59,130,246,0.5)]">
        <Sparkles 
          size={size} 
          className="text-white animate-[bounce_2s_infinite]" 
          strokeWidth={2.5}
        />
      </div>
    </div>
  );
}
